module.exports = __webpack_public_path__ + "img/download(3).d7f65448.png";